import {
  FieldContainer,
  FieldLabel,
  ChipsRow,
  Chip,
  HelperText,
} from './styled'
import { ChipPickerProps } from './types'

/**
 * Multi-select pill row. Click toggles the value in the selected list.
 * Generic over `string | number` so it can drive both numeric pickers
 * (bedroom counts) and string pickers (cities).
 *
 * @param {ChipPickerProps<TValue>} props
 * @returns {JSX.Element}
 */
const ChipPicker = <TValue extends string | number>({
  label,
  options,
  selectedValues,
  onChange,
  helperText,
}: ChipPickerProps<TValue>): JSX.Element => {
  const toggle = (value: TValue): void => {
    if (selectedValues.includes(value)) {
      onChange(selectedValues.filter(existing => existing !== value))
      return
    }

    onChange([...selectedValues, value])
  }

  return (
    <FieldContainer>
      <FieldLabel>{label}</FieldLabel>
      <ChipsRow>
        {options.map(option => {
          const isSelected = selectedValues.includes(option.value)
          return (
            <Chip
              key={String(option.value)}
              type="button"
              isSelected={isSelected}
              onClick={() => toggle(option.value)}
            >
              {option.label}
            </Chip>
          )
        })}
      </ChipsRow>
      {helperText !== undefined && helperText !== '' ? (
        <HelperText>{helperText}</HelperText>
      ) : null}
    </FieldContainer>
  )
}

export default ChipPicker
